import CloseIcon from '@mui/icons-material/Close';
import './styles.scss';

export interface SydBottomMessageProps {
  children: React.ReactNode
  title: string
  handleClose: () => void
}

const SydBottomMessage = (props: SydBottomMessageProps) => {
  const { title, children, handleClose } = props;

  return(
    <div className="syd-bottom-message">
      <div className="bottom-message-title">
        <span>{title}</span>
        <div onClick={handleClose}><CloseIcon /></div>
      </div>

      <div className="bottom-message-content">
        {children}
      </div>
    </div>
  )
}

export default SydBottomMessage;